import * as ActionTypes from 'modules/lockers/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = {};

const setFilters = (state, { payload }) => ({
  ...state,
  ...payload,
});

export default createReducer(initialState, {
  [ActionTypes.SET_DASHBOARD_FILTERS]: setFilters,
});
